import Cookies from 'js-cookie'
import {AppId} from "@/utils/app-info";
import router from '../router/index.js'
let path = process.env.NODE_ENV == "development"?'/':'/SmartAdult';
// let path = process.env.NODE_ENV == "development"?'/':'/SmartAdultTest';


export const setHintStatus = () => {
    localStorage.setItem(AppId+"status", "1");
    setTimeout(()=>{
        console.log("删除状态")
        removeHintStatus();
    },3000)
}
export const getHintStatus = () => {
    return localStorage.getItem(AppId + "status");
}

export const removeHintStatus = () => {
    localStorage.removeItem(AppId + "status");
}

/**
 * 登录用户头像 base64字符串
 * @param avatar
 */
export const setAvatar = (avatar) => {
    localStorage.setItem(AppId+"avatar", avatar);
}

export const getAvatar = () => {
   return localStorage.getItem(AppId + "avatar");
}

export const removeAvatar = () => {
    localStorage.removeItem(AppId + "avatar");
}

/**
 * 登录用户名
 * @param username
 */
export const setUserName = (username) => {
    localStorage.setItem(AppId+"username", username);
}

export const getUserName = () => {
    return localStorage.getItem(AppId + "username");
}

export const removeUserName = () => {
    return localStorage.removeItem(AppId + "username");
}

export const setAppKey = (token) => {
    Cookies.set(AppId+'AppKey', token,{ path });
}

export const getAppKey = () => {
    return Cookies.get(AppId+'AppKey',{ path });
}


/**
 * 登录用户的token
 * @param token
 */
export const setToken = (token) => {
    Cookies.set(AppId+'token', token,{ path });
}

export const getToken = () => {
  return Cookies.get(AppId+'token',{ path });
}

export const removeToken = () => {
    Cookies.remove(AppId+'token',{ path });
}

/**
 * 登录用户权限
 * @param perms
 */
export const setPerms = (perms) => {
    Cookies.set(AppId+"perms",JSON.stringify(perms),{ path })

}

export const getPerms = () => {
    try{
        return JSON.parse( Cookies.get(AppId+"perms",{ path }))
    }catch (e) {
        console.error(e);
        return [];
    }
}
export const removePerms = () => {
    Cookies.remove(AppId+"perms",{ path })
}


/**
 * 登录用户信息
 * @param userInfo
 */
export const setUserInfo = (userInfo) => {
// base64头像  太长了 cookie 放不下
    userInfo.avatar = "";
    Cookies.set(AppId+'userInfo', JSON.stringify(userInfo),{ path });
}

export const getUserInfo = () => {
    try{
        return JSON.parse(Cookies.get(AppId+'userInfo',{ path }));
    }catch (e) {
        console.error(e);
        return {};
    }
}

export const removeUserInfo = () => {
    Cookies.remove(AppId+"userInfo",{ path })
    // if( router.removeRoute ){
    //     router.isAddDynamicMenuRoutes = false;
    //     router.removeRoute('Home')
    //     // router.removeRoute()
    // }
}
export const setImgUrl = (ImgUrl) => {
    if(ImgUrl){
        Cookies.set(AppId+'ImgUrl', ImgUrl,{ path });
    }
}
export const getImgUrl = () => {
    try{
        return  Cookies.get(AppId+'ImgUrl',{ path });
    }catch (e) {
        console.error(e);
        return {};
    }
}
export const removeImgUrl = () => {
    Cookies.remove(AppId+"ImgUrl",{ path })

}
/**
 * 路由权限
 * @param router
 */
export const setRouters = (router) => {
    localStorage.setItem(AppId + 'routers', JSON.stringify(router));
}

export const getRouters = () => {
    return localStorage.getItem(AppId + 'routers');
}

export const removeRouters = () => {
    localStorage.removeItem(AppId + 'routers');
}
export const setTopRouters = (router) => {
    localStorage.setItem(AppId + 'topRouters', JSON.stringify(router));
}

export const getTopRouters = () => {
    return localStorage.getItem(AppId + 'topRouters');
}

export const removeTopRouters = () => {
    localStorage.removeItem(AppId + 'topRouters');
}
export const setAllRouters = (router) => {
    localStorage.setItem(AppId + 'allRouters', JSON.stringify(router));
}

export const getAllRouters = () => {
    return localStorage.getItem(AppId + 'allRouters');
}

export const removeAllRouters = () => {
    localStorage.removeItem(AppId + 'allRouters');
}
